import React from "react";
import {TitlePage} from "../../../component/Page/Title";
import {Button, Col, Row} from "react-bootstrap";
import {ExportTableButton} from "../../../component/Button/ExportTableButton";
import PDFUtils from "../../../utils/PDFUtils";
import XLSXUtils from "../../../utils/XLSXUtils";
import Loading from "../../../component/Loading/Loading";
import Icon from "../../../component/Icon/Icon";

import './PortalCustomHeader.css'

export const PortalCustomHeader = ({readpoint, transaction, activeBell, hasWrongWorkflow}) => {

  if (!transaction) return <Loading/>

  const exportToXLS = (transaction) => {
    XLSXUtils.downloadPortalsXLSX(transaction, readpoint.friendlyName)
  }

  const exportToPDF = (transaction) => {
    PDFUtils.generatePortalPDF(transaction, readpoint.friendlyName);
  }

  return (
    <Row>
      <Col md={8} sm={8} lg={8}>
        <TitlePage smallName={readpoint.friendlyName} title="Operação Portal RFID  "/>
      </Col>
      <Col md={4} className="d-flex justify-content-end">
        <Button disabled={!hasWrongWorkflow} className={`${hasWrongWorkflow && 'shake animated'}`} bsStyle="info" onClick={activeBell}>
          <Icon icon="bell"/>
        </Button>
        <ExportTableButton title="Exportar para PDF"
          onClick={() => exportToPDF(transaction)}
          icon="file-pdf-o"
        />
        <ExportTableButton title="Exportar para XLS"
          onClick={() => exportToXLS(transaction)}
          icon="file-excel-o"
        />
      </Col>
    </Row>
  )
}



// WEBPACK FOOTER //
// ./src/pages/PortalPage/PortalCustomHeader/PortalCustomHeader.js